module.exports = __webpack_public_path__ + "img/n24.2e95002f.jpg";